const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '收录超过20000部电视剧和电影资源，涵盖国产剧、韩剧、美剧、日剧、动漫及院线大片，满足各类观影需求。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清不缓冲',
    desc: '采用多线CDN加速与智能码率自适应技术，1080P高清画质流畅播放，网络波动时自动切换，告别卡顿等待。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端适配',
    desc: '无需下载APP，手机、平板、电脑浏览器直接观看。支持DLNA投屏到大屏电视，客厅追剧更过瘾。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日同步更新',
    desc: '热播剧播出后数小时内上线，院线新片第一时间提供高清版本。自动追更提醒，不错过任何精彩内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500">为什么千万用户选择丫丫影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-7 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}